import { createSelector } from 'reselect';
import lodash from 'lodash';

export const myTasksSelector = state => lodash.get(state, 'myTasks.tasks', []);
export const loadingTasksSelector = state => lodash.get(state, 'myTasks.loading');
export const querySelector = state => lodash.get(state, 'routing.locationBeforeTransitions.query.q');
export const sortSelector = state => lodash.get(state, 'routing.locationBeforeTransitions.query.sort', 'created');
export const orderSelector = state => lodash.get(state, 'routing.locationBeforeTransitions.query.order', 'desc');
export const mySignatureRequestSelector = state => lodash.get(state, 'mySignatureRequests.signatureRequests', []);

export const tasksSelector = createSelector(
    myTasksSelector,
    (tasks) => tasks
);
